import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

var config = {
  apiKey: "AIzaSyBNUwWLGRQdEvy6FFlsAncH4X7sUhSH8R8",
  authDomain: "braziers-nz.firebaseapp.com",
  databaseURL: "https://braziers-nz.firebaseio.com",
  projectId: "braziers-nz",
  storageBucket: "braziers-nz.appspot.com",
  messagingSenderId: "930554357818"
};
if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

let cloneFunction = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

export const clone = cloneFunction;
export const GoogleProvider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export const dataB = firebase.firestore();
export const files = firebase.storage().ref();
const settings = {
  timestampsInSnapshots: true
};
dataB.settings(settings);
dataB.enablePersistence()
  .catch(function (err) {
    if (err.code == 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code == 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  });
export const peopleRef = dataB.collection("people");
export const usersRef = dataB.collection("users");
export const appointmentsRef = dataB.collection("appointments");
export const appointmentTenantsRef = dataB.collection("appointmentTenants");
export const applicationsRef = dataB.collection("applications");
export default firebase;
